import axios from "./axiosInstance";
import {
  FeeApiResponse,
  FeesApiResponse,
  FeeCreatePayload,
  FeeSearchParams
} from "../types/feeTypes";
import { t } from "i18next";

/**
 * Create a new fee
 */
export const createFee = async (payload: FeeCreatePayload): Promise<FeeApiResponse> => {
  const response = await axios.post<FeeApiResponse>("/fees", payload);
  return response.data;
};

/**
 * Search fees with optional parameters
 */
export const getAllFees = async (params: FeeSearchParams): Promise<FeesApiResponse> => {
  const response = await axios.get<FeesApiResponse>("/fees", { params: { ...params } });
  return response.data;
};

/**
 * Fetch a specific fee by ID
 */
export const getFeeById = async (feeId: string): Promise<FeeApiResponse> => {
  const response = await axios.get<FeeApiResponse>(`/fees/${feeId}`);
  return response.data;
};

/**
 * Update an existing fee
 */
export const updateFee = async (feeId: string, payload: Partial<FeeCreatePayload>): Promise<FeeApiResponse> => {
  const response = await axios.put<FeeApiResponse>(`/fees/${feeId}`, payload);
  return response.data;
};

/**
 * Delete a fee
 */
export const deleteFee = async (feeId: string): Promise<FeeApiResponse> => {
  const response = await axios.delete<FeeApiResponse>(`/fees/${feeId}`);
  return response.data;
};



export const createFeeByStudentIds = async (payload: FeeCreatePayload): Promise<FeeApiResponse> => {
  const response = await axios.post<FeeApiResponse>(`/fees/studentIds`, payload);
  return response.data;
};
